import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای تولید شده = قلم‌هایی که item_status آن‌ها produced است.
// پیشروی یک گام: produced → in_warehouse، بازگشت یک گام: produced → in_production
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای تولید شده"
    itemStatus="produced"
    advanceLabel="ورود به انبار"
    advanceConfirmText="آیا ورود این کالا به انبار را تأیید می‌کنید؟"
    advanceSuccessText="کالا وارد انبار محصولات شد و به فهرست کالاها در انبار منتقل گردید."
    canRevert
    advanceRoles={[ROLE.WAREHOUSE_KEEPER]}
    revertRoles={[ROLE.PRODUCTION_EXPERT]}
    emptyText="هیچ کالای تولید شده‌ای وجود ندارد"
  />
);

export default Index;
